import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "classes",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "CourseSetup/modules/Module"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "CourseSetup/components/CreateCourse/containers/CreateCourseModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "CourseSetup/components/EditCourse/containers/CourseDetailsModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const module2 = importedModule1;
          const CreateCourseModule = importedModule2;
          const courseDetailsModule = importedModule3;
          const reducer = module2.default;
          const key = module2.NAME;
          injectReducer(store, {
            key,
            reducer,
          });
          injectReducer(store, {
            key: CreateCourseModule.NAME,
            reducer: CreateCourseModule.default,
          });
          injectReducer(store, {
            key: courseDetailsModule.NAME,
            reducer: courseDetailsModule.default,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
